import Head from "next/head";
import React, { useEffect } from "react";
import { FrontPagesCTA, FrontPagesFooter } from "../components/front-pages/commons";
import AnimatedHeaderText from "../components/front-pages/commons/animated-header-text";
import FrontPagesLayout from "../components/front-pages/front-pages-layout";
import {
  PaymentsFeatures,
  InvoiceLinksHeader,
  InvoiceLinksHowItWorks,
  InvoiceLinksNextLevel,
} from "../components/front-pages/invoice-links";
import { PageTags } from "../components/seo-tags";
import PagesLoaderContext from "../contexts/page-loader-context";

const pageTags: PageTags = {
  title: "Catlog - Invoice Links",
  description:
    "Invoice links helps merchants create invoices embeded in links they can share with customers and get paid with multiple options",
  pageUrl: "/invoice-links",
  image: "https://res.cloudinary.com/catlog/image/upload/v1671181798/seo-banners/Main_Banner.png",
};

const InvoiceLinksPage = () => {
  return (
    <PagesLoaderContext.Provider>
      <FrontPagesLayout
        tags={pageTags}
        colors={{
          main: "#EF940F",
          pastel: "#FEF6EB",
        }}
      >
        <Head>
          <link
            rel="preload"
            as="image"
            href=""
            imageSrcSet="https://res.cloudinary.com/catlog/image/upload/c_scale,w_1500/v1670999575/front-pages/mockups/invoice-links-header-mockup.webp 1500w, https://res.cloudinary.com/catlog/image/upload/c_scale,w_2025/v1670999575/front-pages/mockups/invoice-links-header-mockup.webp 2025w"
            sizes="(max-width: 520px) 1500px, 2025px"
          ></link>
        </Head>
        <main>
          <InvoiceLinksHeader />
          <InvoiceLinksHowItWorks />
          <PaymentsFeatures />
          <InvoiceLinksNextLevel />
          <FrontPagesCTA className="yellow-cta">
            <AnimatedHeaderText
              series={[
                ["Get", "started", "with"],
                ["Invoice", "Links"],
              ]}
              className="!leading-[1]"
            />
          </FrontPagesCTA>
          <FrontPagesFooter />
        </main>
      </FrontPagesLayout>
    </PagesLoaderContext.Provider>
  );
};

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}

export default InvoiceLinksPage;
